<script lang="ts">
					import { defineComponent } from 'vue'
					export default defineComponent({
						name: "undefined"
					})
				</script><template>
	<oss-archive-restore-dialog v-if="showDialog" v-model="ossArchiveRestoreDialogVisible" />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import OssArchiveRestoreDialog from "./oss-archive-restore-dialog.vue";
import {
	initOssArchiveErrorHandler,
	isOssArchiveEmbeddedFrame,
	ossArchiveRestoreDialogVisible
} from "/$/common/utils/oss-archive-handler";

const showDialog = ref(false);
let unsubscribe: (() => void) | undefined;

onMounted(() => {
	showDialog.value = !isOssArchiveEmbeddedFrame();
	unsubscribe = initOssArchiveErrorHandler();
});

onUnmounted(() => {
	unsubscribe?.();
});
</script>
